// extracted by mini-css-extract-plugin
module.exports = {"section":"Section-module--section--2nM98","sectionDark":"Section-module--sectionDark--18lAg Section-module--section--2nM98"};